/* Brain Age LP "What you see": the How it works slider's UX (sections/how-slider.liquid as live has it on 2026-10-12;
   Chris, Slack 2026-10-12, WEB-34). Same behaviour, our cards: the slides sit on top of each other and the active one fades
   in (CSS, 500ms); arrows and dashes under the card; a click on the card's left or right half goes back or forward; the
   ends wrap around; no autoplay (live removed it). The logic below is how-slider's goTo / dots / arrows / card click.
   No JS: the slides stack (CSS, no .is-hs). */
(function () {
  var CARD_W = 1292, PAD_X = 24; // Figma's desktop card width and side margin

  function init(section) {
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-ba-slide]'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('.ba-hs__dot'));
    var win = section.querySelector('.ba-slides__window');
    var currentIndex = 0;
    if (slides.length < 2 || !win) return;

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      currentIndex = index;
      section.setAttribute('data-active-slide', index);
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', i !== index ? 'true' : 'false');
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('ba-hs__dot--active', i === index);
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
        dot.setAttribute('tabindex', i === index ? '0' : '-1');
      });
    }
    section.baGoTo = goTo; // the QA collector shows a slide the way a dash click does (lp-qa-report spec "reveal")

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { goTo(parseInt(dot.getAttribute('data-dot-index'), 10)); });
    });
    var prev = section.querySelector('[data-hs-prev]'), next = section.querySelector('[data-hs-next]');
    if (prev) prev.addEventListener('click', function () { goTo(currentIndex - 1); });
    if (next) next.addEventListener('click', function () { goTo(currentIndex + 1); });
    win.addEventListener('click', function (e) {
      if (e.target.closest('a, button')) return;
      var rect = win.getBoundingClientRect();
      goTo(e.clientX - rect.left > rect.width / 2 ? currentIndex + 1 : currentIndex - 1);
    });

    section.classList.add('is-hs');
    goTo(0);
  }

  // Desktop cards (quote card, What you see card) keep Figma's 1292px width and scale evenly below it.
  function zoom() {
    var w = document.documentElement.clientWidth;
    var z = w >= 769 ? Math.min(1, (w - 2 * PAD_X) / CARD_W) : 1;
    document.documentElement.style.setProperty('--ba-zoom', z.toFixed(4));
    document.documentElement.style.setProperty('--ba-zoom-m', (w < 769 ? Math.min(1, (w - 2 * PAD_X) / 327) : 1).toFixed(4)); // mobile What you see card: Figma's 327, zoomed evenly below 375
    document.documentElement.style.setProperty('--ba-zoom-frame', (w >= 769 ? Math.min(1, w / 1436) : 1).toFixed(4)); // whole-frame rows (chart)
    document.documentElement.classList.add('ba-zoom-ready');
  }
  zoom();
  window.addEventListener('resize', zoom);

  function boot() { document.querySelectorAll('[data-ba-slides]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var s = e.target.querySelector('[data-ba-slides]'); if (s) init(s); });
})();
